import { loadPdfJs, PDF_WORKER_URL } from './pdfjs-loader';

const WORKER_URL = PDF_WORKER_URL;

// Prefetch pdf.js + point worker at the locally-bundled file so it works offline
// (Android WebView / Flutter). Replace worker URL with a blob so it survives
// going offline later in the same session.
(window as any).pdfWorkerSrc = WORKER_URL;
void loadPdfJs()
  .then((pdfjs) => {
    pdfjs.GlobalWorkerOptions.workerSrc = WORKER_URL;
    return fetch(WORKER_URL)
      .then((r) => r.blob())
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        pdfjs.GlobalWorkerOptions.workerSrc = blobUrl;
        (window as any).pdfWorkerSrc = blobUrl;
      });
  })
  .catch(() => {
    /* keep the file URL fallback; viewer will retry on open */
  });
